<template>
  <v-dialog v-model="show" max-width="400">
    <v-card
        class="popup add_store_popup popup-success"
        align="center"
        justify="center"
      >
        <i class="ico-success"
          ><img src="@/assets/img/ico-caution.png" alt=""
        /></i>
        <div class="msg">
          <h3 class="mb-0">{{ $t(title) }}</h3>
        </div>
        <v-row>
          <v-col>
            <span v-text="message" style="font-size: 15px"></span>
          </v-col>
        </v-row>
        <v-card-actions class="d-flex justify-center">
          <v-btn text icon @click="confirm" style="font-size: 13px;" class="btn">{{
            $t("Yes")
          }}</v-btn>
          <v-btn text icon @click="cancel" style="font-size: 13px !important;" class="btn">{{
            $t("No")
          }}</v-btn>
        </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script>
export default {
  data () {
    return {
      show: false,
      title: '',
      message: '',
      resolveFn: null
    }
  },
  methods: {
    open ({ title, message }) {
      this.title = title
      this.message = message
      this.show = true

      return new Promise(resolve => {
        this.resolveFn = resolve
      })
    },
    confirm () {
      this.show = false
      this.resolveFn(true)
    },
    cancel () {
      this.show = false
      this.resolveFn(false)
    }
  }
}
</script>
